/* eslint-disable @typescript-eslint/no-unsafe-return */
// TODO
// API Response를 그대로 쓰는게 아닌, 프론트 UI에 맞게끔 컨버팅 하는 작업을 끼고 사용하도록 구조 변경

import type { OAISchema } from '~/types/openapi';

export type HomeShowcaseListType = ReturnType<typeof convertToHomeShowcase>;
export function convertToHomeShowcase(
  data?: OAISchema['PlacementHomeTopShowcaseListResponse'],
) {
  if (!data) return [];
  const { items, placements } = data;

  const result = items.map((item, index) => {
    return {
      ...placements[index],
      ...item,
      placementName: placements[index].name,
    };
  });

  return result;
}
